import { useGiftDetails } from './hooks'
import React from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CImage,
} from '@coreui/react-pro'
import { path } from '../../../../libs'

export const GiftDetail = () => {
  const { gift, loading } = useGiftDetails()

  if (loading) {
    return <div>Downloading</div>
  }

  return (
    <div>
      <CButton
        color="primary"
        className="mb-2"
        href={path.giftShop.gifts.edit(String(gift.id))}
      >
        Edit
      </CButton>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Gift {gift.id}</strong>
        </CCardHeader>
        <CCardBody>
          {gift.imageSmall && (
            <div className="mt-2">
              <CImage
                rounded
                thumbnail
                src={gift.imageSmall}
                width={200}
                height={200}
              />
            </div>
          )}
          <div className="mt-2">
            <span className="text-muted">name:</span> {gift.name}
          </div>
          <div className="mt-2">
            <span className="text-muted">title:</span> {gift.title}
          </div>
          <div className="mt-2">
            <span className="text-muted">description:</span> {gift.description}
          </div>
          <div className="mt-2"></div>
          <div className="mt-2">
            <span className="text-muted">Cost price:</span> {gift.costPrice}
          </div>
          <div className="mt-2">
            <span className="text-muted">available countries:</span>{' '}
            {gift.availableCountries?.map((item) => ' ' + item)}
          </div>
          <div className="mt-2">
            <span className="text-muted">label:</span> {gift.label}
          </div>
          <div className="mt-2">
            <span className="text-muted">download URL:</span> {gift.downloadUrl}
          </div>
        </CCardBody>
      </CCard>
    </div>
  )
}
